export const BREAKPOINT_TABLET = 767;
export const BREAKPOINT_LARGER_MOBILE = 650;
export const BREAKPOINT_DESKTOP = 991;
export const BREAKPOINT_DESKTOP_1023 = 1023;
export const MILESTOMETERS = 1609.344;
export const METERSTOKM = 1000;
export const REWARDS_REDEMPTION_CLUSTER_CODES = ['MRW', 'P17', '39E', 'MW1'];
